import * as handlers from './index';
import { useState,useRef } from 'react';
import {
  useDisclosure,
  useRadio,
  useRadioGroup,
  useStyleConfig,
} from '@chakra-ui/react';

const State = (props,uid) => {
  const [resumeData, setResumeData] = useState({
    resumes: {},
  });
  const tempBullet = useRef('')
  //https://appstage.resumescripter.com
  const domain = '';
  const [dataToSave, setDataToSave] = useState({
    saved: { resumes: props.member },
    industry: props.industry,
  });

  const navSections = props.section;
  delete props.member.version;
  let resumes = props.member;// props.resume_structure.resumes;
  const guid = props.resume_structure?.guid ?? 0;
  const urlParams = new URLSearchParams(window.location.search);
  let sectionName = 'resumes';
  let demo = urlParams.get('appType');
  if(demo === 'cm') {
    sectionName = 'new-aptitude';
  }
  if(demo === 'int' || demo === 'city') {
    sectionName = 'interview';
  }
  if(demo === 'mi') {
    sectionName = 'interview-coach-home';
  }
  const [sectionData, setSectionData] = useState({
    resumeIndex: 0, //init
    resumeIndustryName: '',
    sectionName: sectionName,
    sectionIndex: 0,
    sectionType: 'section',
    preview: 0,
    industryType: '',
    indIndex: 0,
    modalMessage: '',
    fileUrl:'',
    parsed:false,
    regenCS: true,

    guid: guid,
  });
  const [openBulletRow,setOpenBulletRow] = useState( {
    open:false
  })
  const [interviewQuestion,setInterviewQuestion] = useState( [])
  const [expertiseData,setExpertiseData] = useState( {
    options:[]
  });
  const [interviewTitle,setInterviewTitle] = useState( 'Interview Coach');
  const [loadingSkills,setLoadingSkills] = useState( false);
  const [isAdmin,setIsAdmin] = useState(false);
  const [resumeToDelete,setResumeToDelete] = useState(-1);
  const [computerData,setComputerData] = useState( {
    options:[]
  });
  const [bulletData,setBulletData] = useState( {
    bullets:{},
    unselectedBullets:{},
    selectedBullets:{},
    bulletsFound:'',
    bulletsLoading:false,
    bulletError:'',
    bulletGroup: '',
    bulletModal: {},
    bulletValue: { },
    rerenderToggle:true
  })
  const [aiIndustryData,setAIIndustryData] = useState( {
    aiIndustryQObj:{},
    rerenderToggle:true
  })
  const [aiIndustryPEData,setAIIndustryPEData] = useState( {
    aiIndustryQObj:{},
    rerenderToggle:true
  })
  const [aiopts_state, setaiopts] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isPTOpen, onOpen:onPTOpen, onClose:onPTClose } = useDisclosure();
  const { isOpen: isSpinnerOpen, onOpen:onSpinnerOpen, onClose:onSpinnerClose } = useDisclosure();
  const { isOpen: isBulletOpen, onOpen:onBulletOpen, onClose:onBulletClose } = useDisclosure();
  const { isOpen: isCareerSummaryOpen, onOpen:onCareerSummaryOpen, onClose:onCareerSummaryClose } = useDisclosure();
  const { isOpen: isJobIndustryOpen, onOpen:onJobIndustryOpen, onClose:onJobIndustryClose } = useDisclosure();
  const { isOpen: isNotesModalOpen, onOpen:onNotesModalOpen, onClose:onNotesModalClose } = useDisclosure();
  const { isOpen: isPreviewOpen, onOpen:onPreviewOpen, onClose:onPreviewClose } = useDisclosure();
  const [dataSaved, isDataSaved] = useState(false);
  const [counter, setCounter] = useState('0');
  const [step, setStep] = useState(0);
  const [userID] = useState(uid);
  const [ptMessage,setPTMessage] = useState('');
  const [id, setId] = useState(1);
  const [asError,setASError] = useState({});
  const [sortableList, setSortableList] = useState([]);
  const [editableIndex, setEditableIndex] = useState(0);
  const [menuExpanded, setMenuExpanded] = useState(false);
  const [resumeOpen, setResumeOpen] = useState(false);
  const [spinnerMessage, setSpinnerMessage] = useState('');
  const [spinnerImage, setSpinnerImage] = useState('default.gif');
  const [regenCS ,setRegenCS] = useState(true);
  const [regenSkills, setRegenSkills] = useState(true);
  const [isai, setisai] = useState(false);
  const [messageModal, setMessageModal] = useState(false);
  const [moreSkills,setMoreSkills] = useState({});
  const { getRootProps, getRadioProps } = useRadioGroup({ name: '' });
  const { getInputProps, getCheckboxProps } = useRadio(props);
  const [focus, setFocus] = useState({});
  let variant = 'wrapper';
  const Survey = useStyleConfig('Survey', { variant });
  const contentHeaderStyles = useStyleConfig('ContentHeader', { variant });
  const proTipStyles = useStyleConfig('ProTip', { variant });

  const previewStyles = useStyleConfig('Preview', { variant });
  const previewLetterStyles = useStyleConfig('PreviewLetter', { variant });

  const expertiseStyles = useStyleConfig('Expertise', { variant });
  const personalizationChartStyles = useStyleConfig('PersonalizationChart', {
    variant,
  });
  const multisectionStyles = useStyleConfig('MultiSection', { variant });
  const elementsStyles = useStyleConfig('Elements', { variant });
  const bulletBankStyles = useStyleConfig('BulletBank', { variant });
  const currentYear = new Date().getFullYear();
  let returnProps = {};
  const stateProps = {
    domain: domain,
    imgDomain:domain + '/wp-content/themes/project/images',
    /*isMobile:isMobile[0],
    isDesktop:isDesktop[0],*/
    focus:focus,
    asError:asError,
    setASError:setASError,
    setFocus:setFocus,
    resumes: resumes,
    resumeData: resumeData,
    setResumeData: setResumeData,
    isAdmin: isAdmin,
    setIsAdmin: setIsAdmin,
    resumeToDelete: resumeToDelete,
    setResumeToDelete: setResumeToDelete,
    dataToSave: dataToSave,
    setDataToSave: setDataToSave,
    sectionData: sectionData,
    setSectionData: setSectionData,
    dataSaved: dataSaved,
    isDataSaved: isDataSaved,
    moreSkills:moreSkills,
    setMoreSkills:setMoreSkills,
    interviewTitle:interviewTitle,
    setInterviewTitle:setInterviewTitle,
    interviewQuestion:interviewQuestion,
    setInterviewQuestion:setInterviewQuestion,
    loadingSkills:loadingSkills,
    setLoadingSkills:setLoadingSkills,
    bulletData:bulletData,
    setBulletData: setBulletData,
    isai:isai,
    setisai:setisai,
    openBulletRow:openBulletRow,
    setOpenBulletRow:setOpenBulletRow,
    computerData:computerData,
    setComputerData: setComputerData,
    resumeOpen:resumeOpen,
    setResumeOpen: setResumeOpen,
    spinnerMessage:spinnerMessage,
    setSpinnerMessage: setSpinnerMessage,
    spinnerImage:spinnerImage,
    setSpinnerImage: setSpinnerImage,
    tempBullet: tempBullet,
    aiIndustryData:aiIndustryData,
    setAIIndustryData: setAIIndustryData,
    aiIndustryPEData:aiIndustryPEData,
    setAIIndustryPEData: setAIIndustryPEData,
    aiopts_state:aiopts_state,
    setaiopts:setaiopts,
    messageModal: messageModal,
    setMessageModal: setMessageModal,
    counter: counter,
    setCounter: setCounter,
    step: step,
    setStep: setStep,
    ptMessage: ptMessage,
    setPTMessage: setPTMessage,
    id: id,
    setId: setId,
    sortableList: sortableList,
    setSortableList: setSortableList,
    editableIndex: editableIndex,
    setEditableIndex: setEditableIndex,
    //for ReactSortable
    // jobList: jobList,
    // setJobList: setJobList,
    getRootProps: getRootProps,
    getRadioProps: getRadioProps,
    getInputProps: getInputProps,
    getCheckboxProps: getCheckboxProps,
    isOpen: isOpen,
    onOpen: onOpen,
    onClose: onClose,

    isPTOpen: isPTOpen,
    onPTOpen: onPTOpen,
    onPTClose: onPTClose,
    isSpinnerOpen: isSpinnerOpen,
    onSpinnerOpen: onSpinnerOpen,
    onSpinnerClose: onSpinnerClose,
    isBulletOpen: isBulletOpen,
    onBulletOpen: onBulletOpen,
    onBulletClose: onBulletClose,
    isCareerSummaryOpen: isCareerSummaryOpen,
    onCareerSummaryOpen: onCareerSummaryOpen,
    onCareerSummaryClose: onCareerSummaryClose,
    isJobIndustryOpen: isJobIndustryOpen,
    onJobIndustryOpen: onJobIndustryOpen,
    onJobIndustryClose: onJobIndustryClose,
    isNotesModalOpen: isNotesModalOpen,
    onNotesModalOpen: onNotesModalOpen,
    onNotesModalClose: onNotesModalClose,
    isPreviewOpen: isPreviewOpen,
    onPreviewOpen: onPreviewOpen,
    onPreviewClose: onPreviewClose,
    Survey: Survey,
    contentHeaderStyles: contentHeaderStyles,
    proTipStyles: proTipStyles,
    previewStyles: previewStyles,
    previewLetterStyles: previewLetterStyles,
    personalizationChartStyles: personalizationChartStyles,
    multisectionStyles: multisectionStyles,
    expertiseStyles: expertiseStyles,
    elementsStyles: elementsStyles,
    bulletBankStyles: bulletBankStyles,
    menuExpanded: menuExpanded,
    setMenuExpanded: setMenuExpanded,
    regenCS: regenCS,
    setRegenCS:setRegenCS,
    regenSkills: regenSkills,
    setRegenSkills:setRegenSkills,
    currentYear:currentYear,
    userID: userID,
  };
  returnProps.stateProps = stateProps;
  returnProps.handlers = handlers;
  returnProps.survey = props;
  returnProps.navSections = navSections;
  if (stateProps.sectionData.sectionType === 'industry') {
    returnProps.sections = stateProps.dataToSave.industry['other'];
  } else {
    if (stateProps.sectionData.sectionName === 'resumes') {
      returnProps.sections = props.section['resumes'];//stateProps.resumes[stateProps.sectionData.resumeIndex];
    } else {
      returnProps.sections = props.section[sectionData.sectionName];
    }
  }


  /*returnProps.sections =
    stateProps.sectionData.sectionType === 'industry'
      ? props.survey.industry[stateProps.sectionData.industryType]
      : props.survey.section[stateProps.sectionData.sectionName];
*/
  return returnProps;
};
export default State;
